/**
 * @generated SignedSource<<fd6c323d78b73033abec7b20e2b7e3fd>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type CreateMemberSurveyAnswersCSVDataInput = {
  organizationMembershipId: string;
  surveyContentUsageId: string;
};
export type AdminMembersReportSurveyAnswersTableExportCSVButtonMutation$variables = {
  input: CreateMemberSurveyAnswersCSVDataInput;
};
export type AdminMembersReportSurveyAnswersTableExportCSVButtonMutation$data = {
  readonly response: {
    readonly downloadCSVLink: string | null;
    readonly errors: ReadonlyArray<{
      readonly field: string;
      readonly message: string;
    }> | null;
  };
};
export type AdminMembersReportSurveyAnswersTableExportCSVButtonMutation = {
  response: AdminMembersReportSurveyAnswersTableExportCSVButtonMutation$data;
  variables: AdminMembersReportSurveyAnswersTableExportCSVButtonMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": "response",
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "CreateMemberSurveyAnswersCSVDataResponse",
    "kind": "LinkedField",
    "name": "createMemberSurveyAnswersCSVData",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "downloadCSVLink",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "ValidationError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "field",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "message",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "AdminMembersReportSurveyAnswersTableExportCSVButtonMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "AdminMembersReportSurveyAnswersTableExportCSVButtonMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "b9219ba9205a80a23beb10d21d320cce",
    "id": null,
    "metadata": {},
    "name": "AdminMembersReportSurveyAnswersTableExportCSVButtonMutation",
    "operationKind": "mutation",
    "text": "mutation AdminMembersReportSurveyAnswersTableExportCSVButtonMutation(\n  $input: CreateMemberSurveyAnswersCSVDataInput!\n) {\n  response: createMemberSurveyAnswersCSVData(input: $input) {\n    downloadCSVLink\n    errors {\n      field\n      message\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "18777b5427ff229546e8f9f5cdb7c6fa";

export default node;
